<template>
    <div class="d-flex align-left flex-column">
        <div class="d-flex justify-center flex-wrap">
            <a
                v-for="(element, index) in locations"
                :key="index"
                @click="onSelected(element.id)"
                class="temasek-imgbtn-locat"
            >
                <v-card class="mx-auto" raised>
                    <v-img
                        :src="element.cover_image ? element.cover_image.feature_image : `https://picsum.photos/id/${index + 100}/200/300`"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        height="150"
                    ></v-img>
                    <v-card-text class="text-center font-weight-black">{{
                        element.name
                    }}</v-card-text>
                </v-card>
            </a>
        </div>
        <div class="ma-5 text-center">
            <v-btn @click="onBack()" color="primary" large
                ><v-icon>mdi-chevron-left</v-icon> Back</v-btn
            >
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    computed: {
        locations() {
            return this.$store.getters['location/getLocationByCategoryId'](this.$store.getters['feedback/getCategoryId'])
        }
    },
    created() {
        console.log(this.$store.getters['feedback/getLocationId'])
        console.log(this.$store.getters['location/getLocationByCategoryId'](1))
        console.log(this.$store.getters['location/getLocationByCategoryId'](2))
    },
    mounted() {
        if (this.$store.getters['feedback/getCategoryId'] == null) {
            this.$router.push("/category")
        }
    },
    methods: {
        onBack() {
            this.$router.go(-1);
        },
        onSelected(val) {
            this.$store.commit('feedback/setLocationId', val)
            let score = this.$store.getters['feedback/getScore']
            console.log(score)
            if (score > 1) {
                this.$router.push("/thank-you");
            } else {
                this.$router.push("/feedback");
            }
        }
    }
};
</script>
<style>
.location {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40vh;
    justify-items: center;
}
.routerLink {
    text-decoration: none;
}
.temasek-imgbtn-locat {
    width: 210px;
    margin: 16px;
}
</style>
